import { createAsyncThunk } from "@reduxjs/toolkit";
import { ReportExportService } from "../../services/ReportExportService";
import {
  ReportEmailRequest,
  ReportEmailResponse,
  ReportExportRequest,
} from "../../models/ReportExport.model";

export const SendReportEmail = createAsyncThunk<
  ReportEmailResponse,
  {
    reportData: Omit<
      ReportExportRequest,
      "exportFormat" | "token" | "companyKey"
    >;
    token: string;
    companyKey: string;
    email: { to: string; subject: string; message: string };
    formats: Array<"pdf" | "excel">;
  },
  { rejectValue: string }
>(
  "reportEmail/send",
  async (
    { reportData, token, companyKey, email, formats },
    { rejectWithValue },
  ) => {
    try {
      const request: ReportEmailRequest = {
        reportId: reportData.reportId,
        reportName: reportData.reportName,
        tables: reportData.tables,
        totalRecords: reportData.totalRecords,
        formats,
        to: email.to,
        subject: email.subject,
        message: email.message,
        token,
        companyKey,
      };
      const result = await ReportExportService.sendReportEmail(request);
      if (!result.success) {
        return rejectWithValue(result.message || "Failed to send email");
      }
      return result;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : "Unknown error while sending email",
      );
    }
  },
);
